import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionCtl } from 'lib-klab-core';
import { hasAdminPortalAccess } from 'lib-klab-auth-ui';

export const adminGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);
    const sessionCtl = inject(SessionCtl);

    if (!sessionCtl.loggedInCheckSync() || !hasAdminPortalAccess(sessionCtl.menu)) {
        return router.createUrlTree(['/login'], {
            queryParams: { redirect: state.url },
        });
    }

    return true;
};
